export default __webpack_public_path__ + "static/media/plus.124d3d2f.svg";